import { Controller } from "react-hook-form";
import { Textarea } from "../ui";
import { FormLabel } from "../FormLabel";
import { FormErrorLabel } from "../FormErrorLabel";

const FormTextarea = ({ name, label, control, error, isRequired, ...rest }: any) => {
  return (
    <div className="relative flex flex-col items-start gap-1">
        {label && <FormLabel>{label} <span className="text-red-700">{isRequired ? "*" : ""}</span></FormLabel>}
        <Controller
          name={name}
          control={control}
          render={({ field }) => <Textarea {...field} {...rest} />}
        />
        {error && <FormErrorLabel>{error}</FormErrorLabel>}
    </div>
  );
};

export default FormTextarea;
